module.exports = __webpack_public_path__ + "img/psc.2f36dbe6.png";